enum TerritoryRoutes {
  List = '/territory',
  Item = '/territory/edit/:id',
  Add = '/territory/add',
}

export default TerritoryRoutes
